import React from "react";
import { experienceConst } from "../_constants/ExperienceConst";

function SkillExperienceBasic({
  onSkillExperienceChange,
  selectedValue,
  selectedKey,
}) {
  return (
    <span className="select mt-1">
      <select
        className="form-control bg-transparent"
        onChange={(e) => onSkillExperienceChange(e.target.value)}
        name={selectedKey}
      >
        <option
          disabled={true}
          value=""
          selected={selectedValue === null || selectedValue === ""}
        >
          Experience in Years
        </option>
        {Array.isArray(experienceConst) &&
          experienceConst.map((item) => (
            <option
              key={item.key}
              selected={selectedValue === item.value}
              defaultValue={item.value}
            >
              {item.key}
            </option>
          ))}
      </select>
    </span>
  );
}

export default SkillExperienceBasic;
